import React, { useState } from "react";
import { List, Typography, Card, Badge, Divider, Input, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const TextMessages = ({ messages, onSendMessage }) => {
  const [messageText, setMessageText] = useState("");

  const handleSend = () => {
    if (messageText.trim()) {
      onSendMessage(messageText);
      setMessageText("");
    }
  };

  // Group messages by date
  const groupedMessages = messages.reduce((acc, msg) => {
    const date = msg.UpdatedDate
      ? dayjs(msg.UpdatedDate).format("YYYY-MM-DD")
      : null;
    if (!acc[date]) acc[date] = [];
    acc[date].push(msg);
    return acc;
  }, {});

  return (
    <Card style={{ maxHeight: 500, overflowY: "auto", padding: "4px" }}>
      <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
        <Input
          placeholder="Type a message..."
          value={messageText}
          onChange={(e) => setMessageText(e.target.value)}
          onPressEnter={handleSend}
        />
        <Button type="primary" onClick={handleSend}>
          Send
        </Button>
      </div>
      {Object.entries(groupedMessages).map(([date, msgs]) => (
        <div key={date}>
          {date && (
            <Divider style={{ margin: "8px 0", fontSize: "12px" }}>
              {dayjs(date).format("MMM D, YYYY")}
            </Divider>
          )}
          <List
            dataSource={msgs}
            renderItem={(msg) => (
              <List.Item
                style={{
                  display: "flex",
                  justifyContent:
                    msg.ReceiverType === 0 ? "flex-end" : "flex-start",
                  padding: date ? "4px 0" : "10px 0", // Add vertical spacing if no date divider
                }}
              >
                <div
                  style={{
                    background: msg.ReceiverType === 0 ? "#c8d4e5" : "#f5f5f5", // Lighter, greyer blue
                    padding: "8px 12px", // Adjusted padding
                    borderRadius: "10px",
                    maxWidth: "85%",
                    position: "relative",
                  }}
                >
                  <Typography.Text strong>{msg.ReasonDesc}</Typography.Text>
                  <br />
                  <Typography.Paragraph style={{ whiteSpace: "pre-line" }}>
                    {msg.Message}
                  </Typography.Paragraph>
                  <div
                    style={{
                      fontSize: "10px", // Reduce date size
                      textAlign: "right",
                      marginTop: "3px", // Adjust spacing
                      opacity: 0.7,
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "6px",
                    }}
                  >
                    <div>
                      {msg.ReceiverType === 0 && (
                        <span>
                          {msg.PhoneNumber.replace(
                            /(\d{3})(\d{3})(\d{4})/,
                            "$1-$2-$3"
                          )}
                        </span>
                      )}
                    </div>
                    <div style={{ opacity: 0.7 }}>
                      {msg.ReceiverType === 0 && (
                        <>
                          {msg.DeliveryStatus >= 0 &&
                          msg.DeliveryStatus <= 4 ? (
                            msg.DeliveryStatusDesc
                          ) : (
                            <span style={{ color: "red" }}>
                              <ExclamationCircleOutlined
                                style={{ marginRight: 4 }}
                              />
                              {msg.DeliveryStatusDesc}
                            </span>
                          )}
                        </>
                      )}
                      <span style={{ marginLeft: "8px" }}>
                        {dayjs(msg.UpdatedDate).format("HH:mm")}
                      </span>
                    </div>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </div>
      ))}
    </Card>
  );
};

export default TextMessages;
